import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getVoucher: ["payload"],
  getVoucherLoading: null,
  getVoucherSuccess: ["getVoucherData"],
  getVoucherFailure: ["getVoucherError"],

  getVoucherGmm: ["payload"],
  getVoucherGmmLoading: null,
  getVoucherGmmSuccess: ["getVoucherGmmData"],
  getVoucherGmmFailure: ["getVoucherGmmError"],
});

export { Types };

export default Creators;
